import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

@Injectable()
export class ActivityMonitorService {
  public lastAction: Date;
  private clickListener: () => void;
  private mouseMoveListener: () => void;
  private keypressListener: () => void;
  private inactivityIntervalId: number | null = null;

  constructor(private authService: AuthService) {
    this.resetTimer();
    this.initializeActivityListeners();
  }

  public initializeActivityListeners(): void {
    this.clickListener = () => this.resetTimer();
    this.mouseMoveListener = () => this.resetTimer();
    this.keypressListener = () => this.resetTimer();

    window.addEventListener("click", this.clickListener);
    window.addEventListener("mousemove", this.mouseMoveListener);
    window.addEventListener("keypress", this.keypressListener);
  }

  public resetTimer() {
    console.log('Resetting timer, User is moving');
    this.lastAction = new Date();
  }

  public checkInactivity(timeout: number) {
    console.log('Checking Inactivity')
    this.inactivityIntervalId = window.setInterval(() => {
      const now = new Date();
      const timeDiff = now.getTime() - this.lastAction.getTime();
      console.log('Time Dif', timeDiff)
      console.log('Timeout', timeout)
      if (timeDiff > timeout) {
        // User has been inactive for the timeout duration
        this.authService.logout();
      }
    }, 60000); // check every minute
  }

  public cleanupListeners(): void {
    console.log('Cleaning Events')
    window.removeEventListener("click", this.clickListener);
    window.removeEventListener("mousemove", this.mouseMoveListener);
    window.removeEventListener("keypress", this.keypressListener);

    // Clear the interval
    if (this.inactivityIntervalId !== null) {
      clearInterval(this.inactivityIntervalId);
      this.inactivityIntervalId = null;
    }
  }

}
